import Filter from '../modules/Filter';
import ObjectLock from '../modules/ObjectLock';
import SoftLoad from '../modules/SoftLoad';
class CollectionContainer {
    constructor() {
        this.init();
    }
    init() {
        console.log('UNTUCKit : Container : CollectionContainer : init', this);
        Filter.init();
        ObjectLock.init();
        SoftLoad.init();
    }
}
export default CollectionContainer;
